import * as React from "react";
import { generateUUID } from "../../util";

let tagMap:{[key:string]:any} = {};

export function useTag(data:any) {

    let [tagId,setTagId] = React.useState(generateUUID());

    React.useEffect(()=>{
        tagMap[tagId] = data;
        return () => {
            delete tagMap[tagId];
        }
    });
    
    return tagId;
}

export function getTag(key:string):any  {
    return tagMap[key] || null;
}
